<script type="text/javascript">
	import LoadState from "../Enums/LoadState";
	import "../UI/LayerList/LayerList.scss";
	import LayerListSwitch from "../UI/LayerList/LayerListSwitch.svelte";
	import ModalWindow from "../UI/ModalWindow.svelte";
	import UKHOWindStore from "./UKHOWindStore";
	
	let visible = UKHOWindStore.meta.visible;
	let loadState = UKHOWindStore.meta.loadState;
	let loaded = false;

	let loadedWindCables = UKHOWindStore.meta.layerData.ukho_cables.loadState;
	let visibleWindCables = UKHOWindStore.meta.layerData.ukho_cables.visible;

	let loadedWindStructures = UKHOWindStore.meta.layerData.ukho_structures.loadState;
	let visibleWindStructures = UKHOWindStore.meta.layerData.ukho_structures.visible;

	let loadedOAGSurfaces = UKHOWindStore.meta.layerData.ukho_oag_surfaces.loadState;
	let visibleOAGSurfaces = UKHOWindStore.meta.layerData.ukho_oag_surfaces.visible;

	let loadedOAGPlatforms = UKHOWindStore.meta.layerData.ukho_oag_platforms.loadState;
	let visibleOAGPlatforms = UKHOWindStore.meta.layerData.ukho_oag_platforms.visible;

	let lastUpdated = UKHOWindStore.meta.lastUpdated;
	$: {
		$visible;
		$lastUpdated;
		$visibleWindStructures;
		$visibleWindCables;
		$visibleOAGSurfaces;
		$visibleOAGPlatforms;
		UKHOWindStore.actions.updateFeatureCollection();
		UKHOWindStore.actions.updateVisibility();
	}

	$: {
		loaded = $loadState === LoadState.LOADED;
		if ($visible && $loadState === LoadState.INIT) {
			UKHOWindStore.actions.init();
		}
		if ($loadedWindStructures === LoadState.INIT && $visibleWindStructures) {
			UKHOWindStore.actions.loadWindStructures();
		}
		if ($loadedWindCables === LoadState.INIT && $visibleWindCables) {
			UKHOWindStore.actions.loadWindCables();
		}
		if ($loadedOAGSurfaces === LoadState.INIT && $visibleOAGSurfaces) {
			UKHOWindStore.actions.loadOAGSurfaces();
		}
		if ($loadedOAGPlatforms === LoadState.INIT && $visibleOAGPlatforms) {
			UKHOWindStore.actions.loadOAGPlatforms();
		}
	}

	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

</script>


{#if loaded}
	<ModalWindow
		title={`Offshore Infrastructure`}
		hasCloseButton={true}
		hasBackground={false}
		resizable={true}
		draggable={true}
		fullscreen={false}
		padding={true}
		position="top-right"
		height="70%"
		bind:open={$visible} >

		<p style={hstyle}>Wind Farms</p>
		<div class='layer-list-component'>
			<LayerListSwitch label={"Cables"} bind:checked={$visibleWindCables} loading={$loadedWindCables === LoadState.LOADING} />
			<LayerListSwitch label={"Surface Structures"} bind:checked={$visibleWindStructures} loading={$loadedWindStructures === LoadState.LOADING}/>
		</div>

		<p style={hstyle}> Oil & Gas</p>
		<div class='layer-list-component'>
			<LayerListSwitch label={"Floating Surface Installations"} bind:checked={$visibleOAGSurfaces} loading={$loadedOAGSurfaces === LoadState.LOADING} />
			<LayerListSwitch label={"Platforms"} bind:checked={$visibleOAGPlatforms} loading={$loadedOAGPlatforms === LoadState.LOADING}  />
		</div>

	</ModalWindow>
{/if}
